import { useTranslation } from 'react-i18next';

import useEvents from 'lib/hooks/useEvents';
import DoorsTap from 'lib/Tracking/Srp/SearchFilters/BodyStylesFilter/DoorsTap';
import { useDoorsFilter } from 'lib/hooks/useSrpFilters';

import NumberSelector from 'components/Shared/SearchFilter/NumberSelector';
import SearchFilterSubHeader from 'components/Shared/SearchFilter/SearchFilterSubHeader';

import { SrpDoorCount } from 'types/srpFilters';
import { useContext } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import { DoorCountFacet } from 'lib/apis/SearchApi/types';

const doorOptions = [2, 3, 4] as SrpDoorCount[];

export interface DoorsFilterProps {
  doorCountFacets?: DoorCountFacet;
}

export default function DoorsFilter({ doorCountFacets }: DoorsFilterProps): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();
  const { value, setValue } = useDoorsFilter();

  function handleChange(doorOption: number, isSelected: boolean): void {
    setValue({
      ...value,
      [doorOption]: isSelected,
    });
    logger.log(DoorsTap(doorOption, sourcePage));
  }

  return (
    <>
      <SearchFilterSubHeader subTitle={t('srp.filters.bodyStyles.doors')} />
      <div className="doors-container">
        {doorOptions.map((doorOption) => {
          return (
            <NumberSelector
              key={doorOption}
              number={doorOption}
              isActive={value?.[doorOption]}
              onChange={(isSelected): void => {
                handleChange(doorOption, isSelected);
              }}
              disabled={!doorCountFacets?.[doorOption]}
            />
          );
        })}
      </div>
      <style jsx>{`
        .doors-container {
          width: 184px;
          margin: 0 16px 16px 16px;
          display: flex;
          flex-wrap: wrap;
          gap: 10px 16px;
        }
      `}</style>
    </>
  );
}
